export function stationValidate(station){
    var result = true;

    result = validateId(station.id);
    result = validateName(station.name);
    result = validateUser(station.user);
    result = validateWarehouse(station.warehouse);
    result = validateSlots(station.slots);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name){
    if(typeof name === 'string' && name.trim() !== '') return true;
    else return false;
}

function validateUser(user){
    if(user == null) return true;
    if(!Number.isInteger(user.id)) return false;
    if(typeof user.name !== 'string' || user.name.trim() === '') return false;
    if(typeof user.paternal_surname !== 'string' || user.paternal_surname.trim() === '') return false;
    if(typeof user.email !== 'string' || user.email.trim() === '') return false;
}

function validateWarehouse(warehouse){
    if(!Number.isInteger(warehouse.id)) return false;
    if(typeof warehouse.name !== 'string' || warehouse.name.trim() === '') return false;
}

function validateSlots(slots){
    return Array.isArray(slots) &&
        slots.every(item =>
        typeof item === 'object' &&
        item !== null &&
        typeof item.id === 'number' &&
        !isNaN(item.id) &&
        typeof item.name === 'string' &&
        item.name.trim() !== ''&&
        (typeof item.tote_id === 'number' || item.tote_id == null) &&
        (typeof item.station_id === 'number' || item.station_id == null) &&
        typeof item.position === 'number'
    );
}